import { render, staticRenderFns } from "./ColorPalette.vue?vue&type=template&id=58c34d78&scoped=true&"
import script from "./ColorPalette.vue?vue&type=script&lang=js&"
export * from "./ColorPalette.vue?vue&type=script&lang=js&"
import style0 from "./ColorPalette.vue?vue&type=style&index=0&id=58c34d78&prod&lang=scss&scoped=true&"
import style1 from "./ColorPalette.vue?vue&type=style&index=1&id=58c34d78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c34d78",
  null
  
)

export default component.exports